export default {
    label: 'Select Pack',
    key: 'pack',
    type: 'select',
    multi: false,
    defaultValue: 't20_customer',
    validate: {
        required: true
    },
    data: {
        values: [{
                label: 'T20 Customer',
                value: 't20_customer'
            }
        ]
    }
};
